export const deleteComment = (payload?: any) => ({
  type: "@saga/DELETE_COMMENT",
  payload,
});
